import { render, staticRenderFns } from "./Grammar.vue?vue&type=template&id=3eb30435&scoped=true"
import script from "./Grammar.vue?vue&type=script&lang=js"
export * from "./Grammar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb30435",
  null
  
)

export default component.exports